import { gql } from '@grandvisionhq/graphql';

const solutionLineItemFragment = gql`
  fragment SolutionLineItemFragment on OrderLineItemSolution {
    price {
      productPrice
      totalPaid
    }
    quantity
    product {
      brand
      mainImage
      modelCode
      name {
        locale
        value
      }
      sku
      currentProduct {
        published
      }
      volume
      volumeUnit
    }
  }
`;
const contactLensLineItemFragment = gql`
  fragment ContactLensLineItemFragment on OrderLineItemContactLens {
    price {
      productPrice
      totalPaid
    }
    quantity
    eyeSide
    prescription {
      addition
      axis
      baseCurve
      cylinder
      dominance
      diameter
      power
    }
    product {
      brand
      mainImage
      modelCode
      name {
        locale
        value
      }
      sku
      currentProduct {
        published
      }
      boxQuantity
      replacementFrequency {
        locale
        value
      }
    }
  }
`;
const prescriptionGlassLineItemFragment = gql`
  fragment PrescriptionGlassLineItemFragment on OrderLineItemPrescriptionGlass {
    price {
      productPrice
      totalPaid
    }
    quantity
    configurationDetails {
      configurationType
      description {
        locale
        value
      }
      productPrice
      totalPaid
    }
    prescription {
      ... on AddedGlassesPrescription {
        leftLens {
          pupillaryDistance
          prism
          power
          cylinder
          axis
          addition
        }
        rightLens {
          pupillaryDistance
          prism
          power
          cylinder
          axis
          addition
        }
      }
      ... on EmailPrescription {
        message
      }
      ... on ExistingPrescription {
        message
      }
      ... on FilePrescription {
        prescriptionFileName
        pupillaryDistanceFileName
      }
    }
    product {
      brand
      mainImage
      modelCode
      name {
        locale
        value
      }
      sku
      currentProduct {
        published
      }
      productPrice
      totalPaid
    }
  }
`;
const nonPrescriptionBundleOrderLineItemFragment = gql`
  fragment NonPrescriptionBundleLineItemFragment on OrderLineItemNonPrescriptionBundle {
    quantity
    price {
      totalPaid
      productPrice
    }
    product {
      sku
      currentProduct {
        published
      }
      name {
        locale
        value
      }
      brand
      modelCode
      mainImage
      productPrice
      totalPaid
    }
    configurationDetails {
      configurationType
      description {
        locale
        value
      }
      totalPaid
      productPrice
    }
  }
`;
const contactLensBundleLineItemFragment = gql`
  fragment ContactLensBundleLineItemFragment on OrderLineItemBundle {
    price {
      productPrice
      totalPaid
    }
    quantity
    product {
      sku
      currentProduct {
        published
      }
      name {
        locale
        value
      }
      brand
      modelCode
      mainImage
      bundledProductName {
        locale
        value
      }
      lensType {
        locale
        value
      }
    }
    bundledLineItems {
      ... on OrderLineItemContactLens {
        price {
          productPrice
          totalPaid
        }
        quantity
        eyeSide
        prescription {
          addition
          axis
          baseCurve
          cylinder
          dominance
          diameter
          power
        }
        product {
          brand
          mainImage
          modelCode
          name {
            locale
            value
          }
          sku
          currentProduct {
            published
          }
          # 09.06.22: boxQuantity is disabled explicitly because it breaks the validation on
          # GraphQL side. This property is going to be deprecated from the graph, but is kept for documentation
          # boxQuantity
          replacementFrequency {
            locale
            value
          }
        }
      }
      ... on OrderLineItemSolution {
        ...SolutionLineItemFragment
      }
    }
  }
  ${contactLensLineItemFragment}
  ${solutionLineItemFragment}
`;
const regularLineItemFragment = gql`
  fragment RegularLineItemFragment on OrderLineItemRegular {
    # TODO: price and quantity are always the same on all line items, so maybe we can save some code duplication here
    price {
      productPrice
      totalPaid
    }
    quantity
    product {
      brand
      mainImage
      modelCode
      name {
        locale
        value
      }
      sku
      currentProduct {
        published
      }
    }
  }
`;

export { contactLensBundleLineItemFragment, contactLensLineItemFragment, nonPrescriptionBundleOrderLineItemFragment, prescriptionGlassLineItemFragment, regularLineItemFragment, solutionLineItemFragment };
//# sourceMappingURL=line-item.js.map
